module.exports = __webpack_public_path__ + "media/images/ringrevenue/ranking-3eea5ac7a62c901a3d100708ffb4d0ac.gif";